import { render, staticRenderFns } from "./VoiceDisclaimer.vue?vue&type=template&id=99fed048&scoped=true"
import script from "./VoiceDisclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoiceDisclaimer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VoiceDisclaimer.vue?vue&type=style&index=0&id=99fed048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fed048",
  null
  
)

export default component.exports